const Dashboard = {
    dashboard: () => 'dashboard',
    ReportCharts:() => 'dashboard/reporting/stats'
  }
  export default Dashboard
  